module.exports = __webpack_public_path__ + "static/img/vr_img.4c517caa.png";